import React from 'react';
import './LoadingEllipsis.css';

const LoadingEllipsis = () => {
  return (
    <div className="loading-ellipsis">
      <div className="loading-ellipsis__item" />
      <div className="loading-ellipsis__item" />
      <div className="loading-ellipsis__item" />
    </div>
  );
};

export default LoadingEllipsis;



// WEBPACK FOOTER //
// ./src/client/views/shared/loading-ellipsis/LoadingEllipsis.js